import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55d10343"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "product-card" }
const _hoisted_2 = { class: "product-card__image" }
const _hoisted_3 = {
  key: 0,
  class: "product-card__special-label"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "product-card__content" }
const _hoisted_6 = { class: "product-card__prices" }
const _hoisted_7 = { class: "product-card__price product-card__price--actual" }
const _hoisted_8 = {
  key: 0,
  class: "product-card__price product-card__price--old"
}
const _hoisted_9 = { class: "product-card__name" }
const _hoisted_10 = {
  key: 0,
  class: "product-card__weight"
}
const _hoisted_11 = {
  key: 0,
  class: "product-card__not-in-stock"
}

import { PropType } from 'vue';
import { Product } from '@/types/app';
import helpers from '@/helpers';
import QuantityPanel from '@/components/QuantityPanel.vue';
import IconPercent from '@/icons/icon-percent.vue';
import useShoppingCartStore from '@/store/shopping-cart';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductCard',
  props: {
  product: {
    type: Object as PropType<Product>,
    required: true,
  },
},
  setup(__props) {

const shoppingCartStore = useShoppingCartStore();



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      class: "product-card__wrapper",
      to: { name: 'product', params: { productId: __props.product.productId } }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (__props.product.special)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(IconPercent)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("img", {
            src: __props.product.images[0]?.thumb,
            alt: "item",
            class: "item-img"
          }, null, 8, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(helpers).formatCurrency(__props.product.special || __props.product.price)), 1),
            (__props.product.special)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_unref(helpers).formatCurrency(__props.product.price)), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_9, _toDisplayString(__props.product.name), 1),
          (__props.product.weight)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(__props.product.weight) + _toDisplayString(__props.product.weightUnitLabel), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["to"]),
    (__props.product.quantity === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.$t('notInStock')), 1))
      : (_openBlock(), _createBlock(QuantityPanel, {
          key: 1,
          "model-value": _unref(shoppingCartStore).productQuantity(__props.product.productId),
          max: __props.product.quantity,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = (e) => _unref(shoppingCartStore)
        .changeProductQuantity([{ product: __props.product, quantity: e }]))
        }, null, 8, ["model-value", "max"]))
  ]))
}
}

})